import { render, staticRenderFns } from "./AmetrasImportTemplate.vue?vue&type=template&id=64bea36d&scoped=true&"
import script from "./AmetrasImportTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasImportTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasImportTemplate.vue?vue&type=style&index=0&id=64bea36d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bea36d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VChip,VIcon,VProgressCircular,VProgressLinear})
